// extracted by mini-css-extract-plugin
export default {"optionsColumn":"TransformOptionsBar_optionsColumn__pp7LO","editColumn":"TransformOptionsBar_editColumn__hPXm3"};